import styled from "styled-components"

export const StyledTabLabel = styled.div<{ isActive?: boolean }>`
  cursor: pointer;
  font-size: 21px;
  line-height: 30px;
  font-family: ${(props) => props.theme.fonts.circularBook};
  white-space: nowrap;
  padding-bottom: 8px;
  color: ${(props) => props.theme.colors.darkGrey60};

  &:hover {
    color: ${(props) => props.theme.colors.black};
  }
  ${(props) =>
    props.isActive &&
    `border-bottom: 3px solid ${props.theme.colors.black}; 
    color: ${props.theme.colors.black}; 
    font-family: ${props.theme.fonts.circularMedium};`}

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.darkGrey60};
    ${(props) => props.isActive && `color: ${props.theme.colors.black};`}
  }
`

export const StyledTabLabels = styled.div`
  display: flex;
  gap: 32px;
  overflow: scroll;

  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
